import {Typography} from '@mui/material';
import {IContainerApp} from '../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {changeRouteType} from '../../redux/handleBackBtn/handleBackBtnSlice';
import {useAppBar} from '../../components/appBar/appBarContext';
import RejectIcon from '../../components/icons/RejectIcon';
export default function Reject({setStep}: IContainerApp) {
    const dispatch = useDispatch();
    const {setHeader} = useAppBar();
    useEffect(() => {
        dispatch(changeRouteType({routeType: 'infoDetail'}));
        setHeader('ثبت چک ضمانت', 'Accept');
    }, []);
    return (
        <div
            className="flex flex-col items-center justify-center"
            style={{textAlign: 'center'}}
        >
            <RejectIcon className="mt-10 text-[var(--primary-text-color)]" />
            <Typography className=" !mt-12 !font-bold text-[var(--primary-text-color)]">
                با عرض پوزش با اعطای تسهیلات به شما{' '}
                <span className="primaryErrorColorLight">موافقت نشد</span>.
            </Typography>
        </div>
    );
}
